"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _component = require("@loadable/component");

var _component2 = _interopRequireDefault(_component);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _BaseComponent2 = require("../base/BaseComponent");

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

require("rc-color-picker/assets/index.css");

require("./color.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorPicker = (0, _component2.default)(function () {
  return import("rc-color-picker");
});

var IDColorPicker = function (_BaseComponent) {
  (0, _inherits3.default)(IDColorPicker, _BaseComponent);

  function IDColorPicker(props) {
    (0, _classCallCheck3.default)(this, IDColorPicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDColorPicker.__proto__ || (0, _getPrototypeOf2.default)(IDColorPicker)).call(this, props));

    _this.handleInputChange = function (value) {
      var onChange = _this.props.onChange;

      var newValue = value;
      if (value === null || value === undefined || value.trim() === "") {
        newValue = "";
      }
      _this.setState({ value: newValue }, function () {
        onChange && onChange(newValue, { color: newValue, alpha: 100 });
      });
    };

    _this.handleChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      var onChange = _this.props.onChange;
      var color = value.color;

      if (!_lodash2.default.isEqual(color, _this.state.value)) {
        _this.setState({
          value: color
        }, function () {
          onChange && onChange(color, value);
        });
      }
    };

    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.dataTestID = 'color';
    return _this;
  }

  (0, _createClass3.default)(IDColorPicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!_lodash2.default.has(nextProps, 'value')) {
        return;
      }
      if (nextProps.value !== this.state.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          containerClassName = _props.containerClassName,
          containerStyle = _props.containerStyle,
          className = _props.className,
          style = _props.style,
          placeHolder = _props.placeHolder,
          inputClassName = _props.inputClassName,
          inputStyle = _props.inputStyle,
          disabled = _props.disabled,
          readOnly = _props.readOnly,
          props = (0, _objectWithoutProperties3.default)(_props, ["containerClassName", "containerStyle", "className", "style", "placeHolder", "inputClassName", "inputStyle", "disabled", "readOnly"]);
      var value = this.state.value;

      return _react2.default.createElement(
        "div",
        {
          "data-testid": this.getDataTestId(),
          className: (0, _classnames2.default)("color-picker-container textbox body-wrap", containerClassName, { 'input-disabled': disabled, 'read-only': readOnly }),
          style: (0, _assign2.default)({ paddingRight: 35 }, containerStyle)
        },
        _react2.default.createElement("input", (0, _extends3.default)({}, _lodash2.default.omit(props, ['testId', 'options', 'type']), {
          className: (0, _classnames2.default)('text-input color-picker-input', this.props.inputCls),
          ref: function ref(c) {
            _this2.ref = c;
          },
          onChange: function onChange(e) {
            return _this2.handleInputChange(e.target.value);
          },
          style: (0, _assign2.default)({}, {
            flex: 1,
            border: 0,
            padding: 10,
            height: '100%',
            outline: 0,
            background: 'transparent',
            textAlign: 'left'
          }, this.props.inputStyle),
          value: value
        })),
        _react2.default.createElement("span", {
          className: "icon-field-line",
          style: { width: 1, height: 16, borderLeft: '1px solid #ccc' }
        }),
        _react2.default.createElement(ColorPicker, {
          style: style,
          className: (0, _classnames2.default)("color-picker-handle", className, value === "" ? "color-picker-grey" : "", this.getSubDataTestId('picker')),
          animation: "slide-up",
          color: value,
          onChange: this.handleChange
        })
      );
    }
  }]);
  return IDColorPicker;
}(_BaseComponent3.default);

IDColorPicker.defaultProps = {
  defaultValue: "",
  placeHolder: "Chọn màu",
  inputClassName: undefined,
  inputStyle: undefined
};

exports.default = IDColorPicker;